module.exports = __webpack_public_path__ + "img/logo-white.6966af12.png";